import API from "@/classes/global/API";

export async function useGetChargeableWeight(route, totalWeight, modelValue) {

    // if (!modelValue.dimensions.unitOfMeasure) modelValue.dimensions.unitOfMeasure = 'metric'

    modelValue.dimensions.totalWeight = totalWeight;

    const response = await API.getChargeableWeight(
        modelValue.dimensions.multiLineDims, modelValue.dimensions.unitOfMeasure, route);

    if (response) {

        try {

            modelValue.dimensions.chargeableWeight = response.ChargeableWeight;
            modelValue.dimensions.totalPieces = response.totalPieces
            modelValue.dimensions.cube = response.cube
        } catch (error) {


        }

    }
}
